var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","overflow":"hidden","color":"white"}},[(_vm.list.length === 0)?_c('div',{staticClass:"nothing-data"}):_c('div',{ref:"wrap",staticStyle:{"height":"100%","width":"100%","margin":"auto"},attrs:{"id":"bar"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d78474c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/monitoring/bigComponents/indexSendOrder.vue
// module id = null
// module chunks = 